import { render } from "./BaseLightBox.vue?vue&type=template&id=01456e20&scoped=true"
import script from "./BaseLightBox.vue?vue&type=script&lang=js"
export * from "./BaseLightBox.vue?vue&type=script&lang=js"

import "./BaseLightBox.vue?vue&type=style&index=0&id=01456e20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01456e20"]])

export default __exports__